// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"PrivacyPolicy_Wrapper__1R8bV","Screenshoot__image":"PrivacyPolicy_Screenshoot__image__2851T"};